import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Seo from '@/components/base/Seo';
import Hero from './components/Hero';
import EditorsPicks from './components/EditorsPicks';
import DailyPick from './components/DailyPick';
import NewArrivals from './components/NewArrivals';
import CategoryShowcase from './components/CategoryShowcase';
import RankSection from './components/RankSection';
import Faq from './components/Faq';

const SITE_URL = 'https://www.manhuadao.cn';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '漫画岛',
    url: SITE_URL,
    logo: `${SITE_URL}/logo.png`,
    description: '漫画岛发现好漫频道，编辑精选每日推荐热门新作与潜力佳作。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@manhuadao.cn',
      contactType: 'customer service',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '漫画岛',
    url: SITE_URL,
    description: '漫画岛发现好漫频道，编辑精选每日推荐热门新作与潜力佳作。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '漫画岛 - 发现好漫频道',
    url: `${SITE_URL}/`,
    description: '漫画岛发现好漫频道，编辑精选每日推荐热门新作与潜力佳作。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '什么是漫画岛？', acceptedAnswer: { '@type': 'Answer', text: '漫画岛是一个专注发现好漫的中文漫画推荐平台，编辑每日精选热门新作与潜力佳作。' } },
      { '@type': 'Question', name: '如何快速找到适合我的漫画？', acceptedAnswer: { '@type': 'Answer', text: '可通过编辑精选、每日推荐、新作尝鲜、热门榜单及分类页快速发现适合的漫画。' } },
      { '@type': 'Question', name: '如何联系漫画岛团队？', acceptedAnswer: { '@type': 'Answer', text: '可通过关于我们页面的联系方式或邮箱 contact@manhuadao.cn 与我们联系。' } },
    ],
  },
];

function CtaBand() {
  return (
    <section className="relative overflow-hidden bg-primary-500 py-12 md:py-16">
      <div className="absolute inset-0 bg-gradient-to-r from-primary-600 via-primary-500 to-accent-500 opacity-90"></div>
      <div className="relative mx-auto max-w-4xl px-4 text-center md:px-6">
        <h2 className="font-heading text-3xl text-background-50 md:text-4xl">还差一部好漫入坑？</h2>
        <p className="mx-auto mt-3 max-w-xl text-base text-background-50/90">
          跟着漫画岛的编辑精选与每日推荐，轻松找到下一部让你熬夜追更的作品。
        </p>
        <Link
          to="/category/reXue"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-7 py-3.5 text-base font-bold text-primary-700 transition-colors hover:bg-background-100"
        >
          <i className="ri-compass-3-line text-lg"></i>
          立即发现好漫
        </Link>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Seo
        title="漫画岛 | 发现好漫 · 编辑精选每日推荐"
        description="漫画岛发现好漫频道，编辑精选每日推荐热门新作与潜力佳作。想找下一部入坑作品，来漫画岛探索推荐，挖掘好货不踩雷，追更从此有方向。"
        canonicalPath="/"
        jsonLd={jsonLd}
      />
      <Navbar />
      <main>
        <Hero />
        <EditorsPicks />
        <DailyPick />
        <NewArrivals />
        <CategoryShowcase />
        <RankSection />
        <Faq />
        <CtaBand />
      </main>
      <Footer />
    </>
  );
}